import { Contract, } from 'ethers';
import {
  default as getContractData,
} from './getWethTokenUniswapV2PairContractData';



export default function getWethTokenUniswapV2PairContract(ethersProviderSigner = null) {
  const { address, abi, /*chainId,*/ } = getContractData();
  const contract = new Contract(address, abi, ethersProviderSigner);
  return contract;
}
